import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import theme from '../../../muiTheme';
import Grid from '@mui/material/Grid';
import moment from 'moment';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class MergeInfoDialog extends Component
{


render() {
    return (this.props.mergedIncident) ?
    (
      <Dialog
       titleStyle={styles.errorDialogTitle}
       title="Merge Information"
       open={this.props.open}>
              <DialogContent>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                        <Grid item xs={4}>
                            <b>Incident Name:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.mergedIncident.IncidentName}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Unique Fire Identifier:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.mergedIncident.UniqueFireIdentifier}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Incident Size:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.mergedIncident.IncidentSize}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Fire Discovery Date:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {moment(this.props.mergedIncident.FireDiscoveryDateTime).format("MM/DD/YYYY h:mm A")}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Merge Date:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {moment(this.props.mergedIncident.MergedOnDateTime).format("MM/DD/YYYY h:mm A")}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Record Merge Date:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {moment(this.props.mergedIncident.RecordMergeDate).format("MM/DD/YYYY h:mm A")}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Merged By:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.mergedIncident.MergedByUsername}
                        </Grid>
                        <Grid item xs={4}>
                            <b>Merge Notes:</b>
                        </Grid>
                        <Grid item xs={8}>
                            {this.props.mergedIncident.MergeNotes}
                        </Grid>
                    </Grid>

              </DialogContent>
       <DialogActions>
        <Button onClick={this.props.onRequestClose} color="primary">
          Close
        </Button>
      </DialogActions>
     </Dialog>
    ) : '';
  }
}

export default MergeInfoDialog;
